<template>
    <div class="printer-container">
        <div class="condition-container">
            <el-form :inline="true" :model="queryParams">
                <el-form-item>
                    <el-input v-model="queryParams.imei" clearable placeholder="请输入设备编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="queryParams.printerName" clearable placeholder="请输入设备名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="queryParams.online" clearable placeholder="请选择设备是否在线">
                        <el-option v-for="item in onlineOptions" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="queryParams.status" clearable placeholder="请选择设备状态">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="query(1)">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="showForm()">新增</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="data-container">
            <el-table v-loading="loading" :data="list" stripe border>
                <div slot="empty">
                    <el-empty description="暂无数据"></el-empty>
                </div>
                <el-table-column label="设备类型" width="100">
                    <template slot-scope="scope">
                        <el-tag type="primary" v-if="scope.row.type == 1">云打印机</el-tag>
                        <el-tag type="warning" v-else-if="scope.row.type == 2">蓝牙云盒</el-tag>
                        <el-tag type="danger" v-else>其他</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="imei" label="编号(SN)"></el-table-column>
                <el-table-column label="账号秘钥">
                    <template slot-scope="scope">
                        <div>{{ scope.row.printerUsername }}</div>
                        <div>{{ scope.row.printerPassword }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="printerName" label="名称"></el-table-column>
                <el-table-column label="是否在线" width="100">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.dataflow == 1">云对云</el-tag>
                        <el-tag type="success" v-else-if="scope.row.online == 1">在线</el-tag>
                        <el-tag type="danger" v-else>离线</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="状态" width="100">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.dataflow == 1">云对云</el-tag>
                        <el-tag type="success" v-else-if="scope.row.online == 1 && scope.row.status == 1">正常</el-tag>
                        <el-tag type="danger" v-else>异常</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="toPrintTaskCount" label="待打印" width="100"></el-table-column>
                <el-table-column label="操作" width="374">
                    <template slot-scope="scope">
                        <el-button size="mini" type="info" @click="handleRefresh">
                            <i class="el-icon-refresh"></i>
                        </el-button>
                        <el-dropdown size="mini" split-button type="primary"
                            style="margin-left: 10px; margin-right: 10px;" trigger="click"
                            @visible-change="setCurrPrinter(scope.row)" @command="handleCommand">
                            测试
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="text">普通文字</el-dropdown-item>
                                <el-dropdown-item command="textCut">普通文字(切纸)</el-dropdown-item>
                                <el-dropdown-item command="newOrder" divided>新订单</el-dropdown-item>
                                <el-dropdown-item command="realOrder" divided>完整订单</el-dropdown-item>
                                <el-dropdown-item command="realOrderCut" divided>完整订单(切纸)</el-dropdown-item>
                                <el-dropdown-item command="hurryOrder" divided>催单</el-dropdown-item>
                                <el-dropdown-item command="cancelOrderApply" divided>申请取消订单</el-dropdown-item>
                                <el-dropdown-item command="cancelOrder" divided>订单已取消</el-dropdown-item>
                                <el-dropdown-item command="refundOrder" divided>订单已退款</el-dropdown-item>
                                <el-dropdown-item command="advanceOrder" divided>待处理预约单</el-dropdown-item>
                                <el-dropdown-item command="newNotice" divided>新的提醒消息</el-dropdown-item>
                                <el-dropdown-item command="517" divided>517LOGO</el-dropdown-item>
                                <el-dropdown-item command="HP" divided>好评LOGO</el-dropdown-item>
                                <el-dropdown-item command="JD" divided>京东LOGO</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-button size="mini" type="success" @click="showForm(scope.row)">编辑
                        </el-button>
                        <el-button size="mini" type="warning" :disabled="scope.row.toPrintTaskCount == 0"
                            @click="handleClear(scope.row)">清空
                        </el-button>
                        <el-button size="mini" type="danger" @click="handleDelete(scope.row.id)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="paging-container paging">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryParams.pageNum" :page-sizes="$pageSizes" :page-size="queryParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <!-- 新增或编辑 -->
        <el-dialog :title="title" :visible.sync="dialogFormVisible" :close-on-click-modal="false"
            :before-close="handleClose" width="480px">
            <el-form ref="infoForm" :model="form" :rules="rules" label-width="60px">
                <el-form-item label="编号" prop="imei">
                    <el-input v-model="form.imei" :disabled="form.id ? true : false"></el-input>
                </el-form-item>
                <el-form-item label="名称" prop="printerName">
                    <el-input v-model="form.printerName" maxlength="256"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="handleSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
export default {
    data() {
        return {
            loginInfo: null,
            loading: false,
            headers: null,
            queryParams: {
                pageNum: 1,
                online: null,
                status: null,
                imei: null,
                name: null
            },
            total: 0,
            onlineOptions: [{
                value: 1,
                label: "在线"
            }, {
                value: 0,
                label: "离线"
            }],
            statusOptions: [{
                value: 1,
                label: "正常"
            }, {
                value: 0,
                label: "异常"
            }],
            list: [],
            dialogFormVisible: false,
            title: "添加设备",
            form: {
                id: null,
                imei: null,
                printerName: null
            },
            rules: {
                imei: [
                    { required: true, message: '请输入设备编号', trigger: 'blur' }
                ],
                printerName: [
                    { required: true, message: '请输入设备名称', trigger: 'blur' },
                    { min: 2, max: 64, message: '长度在 2 到 64 个字符', trigger: 'blur' }
                ]
            },
            currPrinter: null
        }
    },
    created() {
        let loginInfoStr = sessionStorage.getItem("loginInfo");
        this.loginInfo = JSON.parse(loginInfoStr);
        let developer = this.loginInfo.developer;
        let token = this.loginInfo.token;
        this.headers = {
            "Zonelink-Id": developer.id,
            "Zonelink-Username": developer.mobile,
            "Zonelink-Password": developer.password,
            "Zonelink-Token": token
        };
        this.queryParams.pageSize = this.$pageSizes[0];
        this.query();
    },
    methods: {
        handleSizeChange(val) {
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = val;
            this.query();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.query();
        },
        query(pageNum) {
            if (pageNum) {
                this.queryParams.pageNum = pageNum;
            }
            this.loading = true;
            this.axios.get(this.$apiUrl + "/developbackend/listPrinter", {
                params: this.queryParams,
                headers: this.headers
            }).then(res => {
                this.loading = false;
                if (res.data.code == 200) {
                    this.total = res.data.total;
                    this.list = res.data.rows;
                } else if (res.data.code == 403) {
                    this.$showErrorMsg(res.data.msg);
                    // 清除session并跳转到登录页面
                    sessionStorage.removeItem("loginInfo");
                    this.$router.push("/login");
                } else {
                    this.$showErrorMsg(res.data.msg);
                }
            });
        },
        showForm(item) {
            this.dialogFormVisible = true;
            if (item) {
                this.form = Object.assign({}, item);
                this.title = "设置设备名称";
            } else {
                this.title = "添加设备";
            }
        },
        handleClose() {
            this.form = {
                id: null,
                imei: null,
                printerName: null
            };
            this.$refs.infoForm.resetFields();
            this.dialogFormVisible = false;
        },
        handleSubmit() {
            this.$refs["infoForm"].validate((valid) => {
                if (valid) {
                    if (this.form.id) {
                        this.handleEdit();
                    } else {
                        this.handleAdd();
                    }
                }
            });
        },
        handleAdd() {
            this.axios.post(this.$apiUrl + "/developbackend/addPrinter", this.form, {
                headers: this.headers
            }).then(res => {
                if (res.data.code != 200) {
                    this.$showErrorMsg(res.data.msg);
                } else {
                    this.$showSuccessMsg("恭喜您，绑定成功啦~");
                    this.dialogFormVisible = false;
                    this.handleCurrentChange(1);

                    // 更新已绑定设备数量
                    this.asyncPrinterCount(1);
                }
            });
        },
        handleEdit() {
            this.axios.put(this.$apiUrl + "/developbackend/editPrinterName", this.form, {
                headers: this.headers
            }).then(res => {
                if (res.data.code != 200) {
                    this.$showErrorMsg(res.data.msg);
                } else {
                    this.$showSuccessMsg("恭喜您，设置设备名称成功啦~");
                    this.dialogFormVisible = false;
                    this.query();
                }
            });
        },
        handleRefresh() {
            this.query();
        },
        setCurrPrinter(item) {
            this.currPrinter = item;
        },
        handleCommand(command) {
            let printContent = "";
            if (command == 'text') { // 测试打印普通文字
                printContent = "亲，欢迎使用众联云打印服务，测试打印正常。";
            } else if (command == 'textCut') { // 测试打印普通文字(切纸)
                printContent = "亲，欢迎使用众联云打印服务，测试打印正常。<CUT>";
            } else if (command == 'newOrder') { // 测试打印新订单
                printContent = `<PLMC>c1</PLMC><517><CB><BOLD>新订单测试</BOLD></CB><C>* 伍幺柒演示店铺 *</C><CL>#午1 预订单</CL><HP>`;
            } else if (command == 'realOrder') { // 测试打印完整订单
                printContent = `<PLMC>c1</PLMC><517><CB><BOLD>阿里郎</BOLD></CB><C>* 烧烤大厨 *</C><CL>午#2 预订单</CL><CL>今天11:00送达</CL><CB>--已在线支付--</CB><LINE->订单编号：23081627042080017011<BR>商家电话：13600093009<BR>客服电话：18138794144<BR>下单电话：18138794144<BR>下单时间：2023-08-16 00:08:42<BR><LINE-><GROUP><LINE><ITEM>招牌烤肠(必选起购5)</ITEM><ITEM>x5</ITEM><ITEM>￥10.8元</ITEM></LINE></GROUP><LINE-><GROUP><LINE><ITEM>鸡扒饭</ITEM><ITEM>x1</ITEM><ITEM>￥15.8元</ITEM></LINE></GROUP><LINE-><GROUP><LINE><ITEM>蜜汁叉烧饭+老火汤</ITEM><ITEM>x1</ITEM><ITEM>￥21.8元</ITEM></LINE></GROUP><LINE-><GROUP><LINE><ITEM>商品价</ITEM><ITEM>￥0.0元</ITEM></LINE><LINE><ITEM>包装费</ITEM><ITEM>￥0.0元</ITEM></LINE><LINE><ITEM>配送费</ITEM><ITEM>￥0.0元</ITEM></LINE></GROUP><LINE-><GROUP><LINE><ITEM>客户实付</ITEM><ITEM>￥0.0元</ITEM></LINE></GROUP><LINE-><B>演示第一个分区第一分区第一楼7楼777<BR>熊大<BR>13600093009</B><BR><LINE-><C><QRCODE>23081627042080017011</QRCODE></C><TITLE> #2完 </TITLE><HP>`;
            } else if (command == 'realOrderCut') { // 测试打印完整订单(切纸)
                printContent = `<PLMC>c1</PLMC><517><CB><BOLD>阿里郎</BOLD></CB><C>* 烧烤大厨 *</C><CL>午#2 预订单</CL><CL>今天11:00送达</CL><CB>--已在线支付--</CB><LINE->订单编号：23081627042080017011<BR>商家电话：13600093009<BR>客服电话：18138794144<BR>下单电话：18138794144<BR>下单时间：2023-08-16 00:08:42<BR><LINE-><GROUP><LINE><ITEM>招牌烤肠(必选起购5)</ITEM><ITEM>x5</ITEM><ITEM>￥10.8元</ITEM></LINE></GROUP><LINE-><GROUP><LINE><ITEM>鸡扒饭</ITEM><ITEM>x1</ITEM><ITEM>￥15.8元</ITEM></LINE></GROUP><LINE-><GROUP><LINE><ITEM>蜜汁叉烧饭+老火汤</ITEM><ITEM>x1</ITEM><ITEM>￥21.8元</ITEM></LINE></GROUP><LINE-><GROUP><LINE><ITEM>商品价</ITEM><ITEM>￥0.0元</ITEM></LINE><LINE><ITEM>包装费</ITEM><ITEM>￥0.0元</ITEM></LINE><LINE><ITEM>配送费</ITEM><ITEM>￥0.0元</ITEM></LINE></GROUP><LINE-><GROUP><LINE><ITEM>客户实付</ITEM><ITEM>￥0.0元</ITEM></LINE></GROUP><LINE-><B>演示第一个分区第一分区第一楼7楼777<BR>熊大<BR>13600093009</B><BR><LINE-><C><QRCODE>23081627042080017011</QRCODE></C><TITLE> #2完 </TITLE><HP><CUT>`;
            } else if (command == 'hurryOrder') { // 测试打印催单
                printContent = `<PLMC>c4</PLMC><CB><BOLD>测试打印催单</BOLD></CB>`;
            } else if (command == 'cancelOrderApply') { // 测试打印申请取消订单
                printContent = `<PLMC>c5</PLMC><CB><BOLD>测试打印申请取消订单</BOLD></CB>`;
            } else if (command == 'cancelOrder') { // 测试订单已取消
                printContent = `<PLMC>c6</PLMC><CB><BOLD>测试订单已取消</BOLD></CB>`;
            } else if (command == 'refundOrder') { // 测试订单已退款
                printContent = `<PLMC>c7</PLMC><CB><BOLD>测试订单已退款</BOLD></CB>`;
            } else if (command == 'advanceOrder') { // 测试待处理预约单
                printContent = `<PLMC>c8</PLMC><CB><BOLD>测试待处理预约单</BOLD></CB>`;
            } else if (command == 'newNotice') { // 测试新消息提醒
                printContent = `<PLMC>cb</PLMC><CB><BOLD>测试新消息提醒</BOLD></CB>`;
            } else if (command == '517') { // 测试517LOGO
                printContent = `<517>`;
            } else if (command == 'HP') { // 测试好评LOGO
                printContent = `<HP>`;
            } else if (command == 'JD') { // 测试京东LOGO
                printContent = `<JDWM>`;
            }

            let params = {
                imei: this.currPrinter.imei,
                developerPrinterId: this.currPrinter.id,
                content: printContent
            }
            this.axios.post(this.$apiUrl + "/developbackend/printTest", params, {
                headers: this.headers
            }).then(res => {
                if (res.data.code == 420) {
                    this.$showErrorMsg(res.data.msg);
                    this.currPrinter.online = 0;
                } else if (res.data.code == 421) {
                    this.$showErrorMsg(res.data.msg);
                    this.currPrinter.status = 0;
                } else if (res.data.code == 200) {
                    this.$showSuccessMsg("亲，打印任务已成功下发啦~");
                } else {
                    this.$showErrorMsg(res.data.msg);
                }
            });
        },
        handleClear(developerPrinter) {
            this.$confirm('亲，是否确认清空该设备的待打印任务？', '确认信息').then(() => {
                this.axios.put(this.$apiUrl + "/developbackend/cleanPrintTask/" + developerPrinter.id, {}, {
                    headers: this.headers
                }).then(res => {
                    if (res.data.code != 200) {
                        this.$showErrorMsg(res.data.msg);
                    } else {
                        developerPrinter.toPrintTaskCount = 0;
                        this.$showSuccessMsg("亲，待打印任务已成功清空啦~");
                    }
                });
            }).catch(() => { });
        },
        handleDelete(developerPrinterId) {
            this.$confirm('亲，是否确认解绑该设备？', '确认信息').then(() => {
                this.axios.delete(this.$apiUrl + "/developbackend/removePrinter/" + developerPrinterId, {
                    headers: this.headers
                }).then(res => {
                    if (res.data.code != 200) {
                        this.$showErrorMsg(res.data.msg);
                    } else {
                        this.$showSuccessMsg("亲，您的设备已成功解绑啦~");
                        this.handleCurrentChange(1);

                        // 更新已绑定设备数量
                        this.asyncPrinterCount(-1);
                    }
                });
            }).catch(() => { });
        },
        asyncPrinterCount(val) {
            this.loginInfo.printerCount += val;
            sessionStorage.setItem("loginInfo", JSON.stringify(this.loginInfo));
        }
    }
}
</script>


<style scoped>
.printer-container {
    height: 100%;
    padding-top: 5px;
    display: flex;
    flex-direction: column;
}

.data-container {
    overflow-y: scroll;
}
</style>


// WEBPACK FOOTER //
// printer.vue?1606f41c